import React, { useEffect, useState } from "react";
import { Instagram } from "lucide-react";

const INSTAGRAM_DM_URL = "https://ig.me/m/zozoventure";

/**
 * Persistent bottom-right "DM us on Instagram" button.
 * Chosen over WhatsApp because we don't have a phone number, and IG DM is
 * already the primary messaging channel for the brand. Indian audiences
 * respond to messaging-first CTAs far better than email-first CTAs.
 */
export default function FloatingChatButton() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Delay mount to avoid flashing on first paint / hydration
    const t = setTimeout(() => setMounted(true), 400);
    return () => clearTimeout(t);
  }, []);

  return (
    <a
      href={INSTAGRAM_DM_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Message ZOZO Venture on Instagram (opens in new tab)"
      data-testid="floating-chat-button"
      className={`fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 flex items-center gap-2 text-white border-2 border-black shadow-[4px_4px_0_0_rgba(0,0,0,1)] px-4 py-3 font-semibold text-sm hover:shadow-[2px_2px_0_0_rgba(0,0,0,1)] hover:translate-x-[2px] hover:translate-y-[2px] transition-all group ${
        mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      style={{
        transitionDuration: "260ms",
        // Official Instagram brand radial gradient
        background:
          "radial-gradient(circle at 30% 107%, #FDF497 0%, #FDF497 5%, #FD5949 45%, #D6249F 60%, #285AEB 90%)",
      }}
    >
      <span className="relative inline-flex">
        <Instagram size={18} strokeWidth={2.25} />
        <span
          aria-hidden
          className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-white ring-2 ring-black animate-pulse"
        />
      </span>
      <span className="hidden sm:inline">DM us — reply in 2 hrs</span>
      <span className="sm:hidden">DM us</span>
    </a>
  );
}
